import { Component, EventEmitter, Input, Output, SimpleChange, SimpleChanges, ViewChild } from '@angular/core';
import { Message, ConfirmationService, ConfirmEventType, MenuItem } from 'primeng/api';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { CheckBoxQuestion } from 'src/app/misc/component/dynamic-form/question-checkbox';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';

import { TranslatorPipe } from 'src/app/services/translator.pipe';


@Component({
  selector: 'app-survey-type',
  templateUrl: './survey-type.component.html',
  styleUrls: ['./survey-type.component.scss']
})
export class SurveyTypeComponent {
  skelition = true;
  @Output() updateDataEvent: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;
  messages: Message[] = [];
  translator: TranslatorPipe = new TranslatorPipe()
  @Input() tags: any[] = [];

  header = 'Survey Type';
  links: link[] = [
    {
      name: 'رجوع',
      icon: 'pi pi-angle-right',
      link: '/survey',
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: 'الاستبيانات', link: '/survey' },
    { name: 'Survey-Type', link: '/survey-type' },
  ];
  stats: stat[] = [];

  menuItems: MenuItem[] = [    
    {
      label: '<span class="mx-3">تعديل</span>',
      escape: false,
      icon: 'pi pi-refresh',
      command: () => {
        this.actionCall({ id: this.operationType._id, action: 'Update' })
      },
      visible: this.hasPermission('SURVEY_TYPE', 'u')
    },
    {
      label: '<span class="mx-3">حذف</span>',
      escape: false,
      icon: 'pi pi-fw pi-trash',
      command: () => {
        this.actionCall({ id: this.operationType._id, action: 'Delete' })
      },
      visible: this.hasPermission('SURVEY_TYPE', 'd')
    }
  ];

  updateOnlyMenuItem: MenuItem[] = [
    {
      label: '<span class="mx-3">تعديل</span>',
      escape: false,
      icon: 'pi pi-refresh',
      command: () => {
        this.actionCall({ id: this.operationType._id, action: 'Update' })
      },
      visible: this.hasPermission('SURVEY_TYPE', 'u')
    },
  ];

  questions: QuestionBase<string>[] = [];

  // Update data
  updateModal = false;
  updateData: any;
  updateQuestions: any;
  operationType: any;
  openCreateModal: boolean = false;
  createdInfo:any;
  openInfoModal: boolean = false;

  @Input() currentSurvey: any;
  @Input() data: any[] = [];
  @Output() surveys: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService
  ) { }

  ngOnInit() {
    this.tags = this.tags.filter(t => t.value != 'MASTER_TAG')
    this.makequestion();
  }

  hasPermission(flag: string, unit: string): boolean {
    return this.permissionService.hasPermission(flag, unit);
  }

  ngOnChanges(simpleChange: SimpleChanges) {
    if (simpleChange['tags']) {
      this.tags = this.tags.filter(t => t.value != 'MASTER_TAG')
      this.makequestion();
    }
  }

  changeCurrentSurvey(survey: any) {
    this.currentSurvey = survey;
    this.surveys.emit(this.currentSurvey);
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  openTypeMenu(menu: any, event: any, type: any) {
    this.operationType = type;
    menu.toggle(event);
  }

  makequestion() {
    console.log('TAGS', this.tags);
    this.questions = [
      new TextboxQuestion({
        key: 'name',
        label: 'نوع الاستبيان',
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      })
    ];

    if (this.tags.length > 1) {
      this.questions.push(new DropdownQuestion({
        key: 'tag',
        label: this.translate('Tag'),
        required: true,
        options: this.tags.map(e => {
          return { ...e, value: e._id }
        }),
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }));
    }

    this.questions.push(
      new CheckBoxQuestion({
        key: 'requiredAttendance',
        label: this.translate('Mark Attendance'),
        order: 1,
        className: 'col-md-12 col-sm-12 col-12',
        value: false
      }),

      new DropdownQuestion({
        key: 'active',
        label: 'الحالة',
        options: [
          { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
          { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
        ],
        order: 4,
        className: 'col-md-12 col-sm-12 col-12',
        value: true,
        visibility: "false"
      })
    );


  }

  receiveData = async ($event: any) => {
    try {
      let data = $event;
      if (this.tags.length == 1) {
        data.tag = this.tags[0]._id
      }
      let res = await this.dataService.postData('survey-type', data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error') },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.DynamicFormComponent.resetForm();
      this.updateDataEvent.emit({});
      this.openCreateModal = false;
    } catch (error) {
      console.log(error);
    }
  };

  UpdateData = async ($event: any) => {
    try {
      let data: any = $event;
      data._id = this.updateData._id;
      let res = await this.dataService.postData(
        'survey-type',
        data,
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.updateModal = false;
      this.updateData = undefined;
      this.updateDataEvent.emit({});
    } catch (error) {
      console.log(error);
    }
  };

  actionCall($event: any) {
    console.log($event);
    switch ($event.action) {
      case 'Delete':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
          header: this.translate('Confirmation message'),
          icon: 'pi pi-exclamation-triangle',
          action: () => this.deleteCatagory($event.id),
        });
        break;
      case 'Update':
        this.updateData = this.operationType;
        this.updateQuestions = [
          new TextboxQuestion({
            key: 'name',
            label: 'نوع الاستبيان',
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.name,
            className: 'col-12',
          }),
          new DropdownQuestion({
            key: 'active',
            label: 'الحالة',
            required: true,
            value: this.updateData?.active,
            options: [
              { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
              { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
            ],
            order: 4,
            className: 'col-12',
          }),
        ];
        this.updateModal = true;
        break;
      default:
        console.log('Unknown color');
        break;
    }
  }

  deleteCatagory = async (id: string) => {
    try {
      let res = await this.dataService.deleteData(`survey-type/${id}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.updateDataEvent.emit({});
    } catch (error) {
      console.log(error);
    }
  };

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  hasCreatedBy(type: any) {
    let menuItems: MenuItem[] = [...this.menuItems];
    if (type.createdBy) {
      let info: MenuItem = {
        label: '<span class="mx-3">تم الإنشاء من قبل</span>',
        escape: false,
        icon: 'pi pi-info',
        command: () => {
          this.openInfoModal = true;
          this.createdInfo = type;
        }
      };
      menuItems.push(info);
    }
    return menuItems;
  }

  getName(name: any) {
    if (!!name) {
      return name?.first + " " + name?.middle + " " + name?.last;
    }
    return "-"
  }
  
}
